/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CloudProvidersEnum } from './cloudProvidersEnum';
import { ServiceTypeEnum } from './serviceTypeEnum';


export interface ModifyDNSRecordsSpec { 
    service_type: ServiceTypeEnum;
    provider: CloudProvidersEnum;
    /**
     * Cloud Provider Region ID
     */
    region: string;
    /**
     * Array of IPs to create records
     */
    create_record?: Array<string>;
    /**
     * Array of FQDNs to delete
     */
    delete_record?: Array<string>;
    /**
     * Should the FQDN scheme be old style (vcdr-35-165-175-28.staging.app.vcdr.vmware.com) or new (35-165-175-28-us-west-2.console.ds-stg.vmware.com). This applies only for VCDR service type. While deleting records, please use correct scheme and DNS record entry in delete_record. If deleting records like 35-165-175-28-us-west-2.console.ds-stg.vmware.com, then old_scheme should be false.
     */
    old_scheme?: boolean;
}
export namespace ModifyDNSRecordsSpec {
}


